module.exports = {
      id: "scorpio-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#scorpio",
      toString: function () {
        return this.url;
      }
    }